import { render, staticRenderFns } from "./AdminEditproduct.vue?vue&type=template&id=1b4e7457"
import script from "./AdminEditproduct.vue?vue&type=script&lang=js"
export * from "./AdminEditproduct.vue?vue&type=script&lang=js"
import style0 from "./AdminEditproduct.vue?vue&type=style&index=0&id=1b4e7457&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports